import { CSSProperties } from 'react';

export const navbarStyle: CSSProperties = {
  backgroundImage:
    'linear-gradient(to right, rgba(106,164,184,0.95) 0%, #557ebb 100%)',
};

export const dropdownStyle: CSSProperties = {
  zIndex: 1001,
};
